import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Content from '../Component/MediaDetailPage/Content'
import { useParams } from 'react-router-dom'
import { useAuth } from '../Context/ContextProvider'
import { useState } from 'react'
import { useEffect } from 'react'
function MediaDetailPage() {
    const {id}=useParams()
    const {getMediaDetails}=useAuth()
    const [mediaDetail, setMediaDetail] = useState(null)
    useEffect(()=>{
        const fetchMediaDetail=async()=>{
            const resp=await getMediaDetails(id)
            if(resp.success){
                setMediaDetail(resp.data)
            }
        }
        fetchMediaDetail()
    },[id])
    return (
        <div>
            <NavBar/>
            <Content mediaDetail={mediaDetail}/>
            <Footer/>
        </div>
    )
}
export default MediaDetailPage